export enum Color {
    greenDark= '#004e64',
    blueMedium= '#00a5cf',
    blueLight= '#64dfdf',
    aquamarine= '#9fffcb',
    greenMedium= '#25a18e',
    greenLight= '#7ae582',
    orange= '#ff825c',
    yellow='#f8cc3d'
}